import React from 'react';
import styled from 'styled-components';
// eslint-disable-next-line no-restricted-imports
import { Toaster } from 'react-hot-toast';
import Icon from './Icon';

/**
 * NOTE: This wrapper is primarily for locally scoped toast variables
 */
const Wrapper = styled.span`
  --toast-default-background: var(--smurf-blood);
  --toast-default-font-color: var(--white);

  --toast-success-background: var(--ice-ice-baby);
  --toast-success-border-color: var(--cutecumber);
  --toast-success-font-color: var(--pleather);
  --toast-success-icon-color: var(--cutecumber);

  --toast-error-background: var(--bubble-tape);
  --toast-error-border-color: var(--motorola-razr);
  --toast-error-font-color: var(--pleather);
  --toast-error-icon-color: var(--pink-power-ranger);
`;

const Prefix = styled(Icon)`
  font-size: var(--large);

  ${({ kind }) => {
    switch (kind) {
      case 'success':
        return 'color: var(--toast-success-icon-color)';

      case 'error':
        return 'color: var(--toast-error-icon-color)';

      default:
        return '';
    }
  }}
`;

/**
 * NOTE: This component is not to be used directly, rather as a global component
 *       high up in the render tree. Instead, use the toast API provided by
 *       `next/lib/toast` to render notifications.
 */
export default function Toast() {
  return (
    <Wrapper>
      <Toaster
        position="bottom-left"
        toastOptions={{
          duration: 3000,
          style: {
            background: 'var(--toast-default-background)',
            borderRadius: '12px',
            color: 'var(--toast-default-font-color)',
            justifyContent: 'flex-start',
            padding: '16px',
          },

          success: {
            icon: <Prefix icon="check-circle" kind="success" />,
            style: {
              background: 'var(--toast-success-background)',
              border: '1px solid var(--toast-success-border-color)',
              color: 'var(--toast-success-font-color)',
            },
          },

          error: {
            icon: <Prefix icon="exclamation-circle" kind="error" />,
            style: {
              background: 'var(--toast-error-background)',
              border: '1px solid var(--toast-error-border-color)',
              color: 'var(--toast-error-font-color)',
            },
          },
        }}
      />
    </Wrapper>
  );
}
